import { Component, Input } from '@angular/core';
import { IScoreOverallConversational } from 'src/app/interfaces/iscore-overall-conversational';
import { ScoreArrayItem } from 'src/app/utils/enums/result/resultConversational.enum';

@Component({
  selector: 'app-result-overall-score',
  standalone: true,
  templateUrl: './result-overall-score.component.html',
  styleUrls: ['./result-overall-score.component.scss'],
})
export class ResultOverallScoreComponent {
  @Input() scoresArray: ScoreArrayItem[] = [];
  @Input() scoreOverall: IScoreOverallConversational | undefined;
}
